export enum RolesEnum {
    Admin = 1,
    Member = 0,
    Manager = 2,
    SuperAdmin = 3
}

export const RoleOptions = [RolesEnum.Admin, RolesEnum.Member, RolesEnum.Manager];
